import { Navigate } from "react-router-dom";
import { useAdminAuth } from "../../context/AdminAuthContext";

const AdminNonAuthLayout = ({ children }) => {
  const { isAuthenticated, isStaff } = useAdminAuth();

  if (isAuthenticated) {
    return isStaff ? (
      <Navigate to="/dashboard-staff" replace />
    ) : (
      <Navigate to="/dashboard" replace />
    );
  }

  return children;
};

export default AdminNonAuthLayout;

// import React from 'react';
// import { Navigate } from 'react-router-dom';

// const NonAuthLayout = (props) => {
//   if (localStorage.getItem('carRental-userData')) {
//     return (
//       <Navigate to={{ pathname: '/dashboard' }} />
//     );
//   }

//   return (
//     <React.Fragment>
//       {props.children}
//     </React.Fragment>
//   )
// }

// export default NonAuthLayout
